import {Component, Input, OnInit} from '@angular/core';
import {SelectConfig} from '../model/select-config';
import {DatatableColumn} from '../model/column/datatable-column';
import {ColumnTypeEnumeration} from '../model/column/column-type.enumeration';
import {ActionColumn} from '../model/column/action-column';
import {AlignColumnsEnumeration} from '../model/column/align-columns.enumeration';

@Component({
  selector: 'nc-cell-dispatcher',
  templateUrl: './nc-cell-dispatcher.component.html',
  styleUrls: ['./nc-cell-dispatcher.component.scss']
})
export class NcCellDispatcherComponent implements OnInit {
  @Input() column: DatatableColumn;
  @Input() rowData: any;
  @Input() selectConfig: SelectConfig;
  readonly columnType = ColumnTypeEnumeration;
  readonly alignmentType = AlignColumnsEnumeration;
  alignClass: string;

  constructor() {
  }

  ngOnInit(): void {
    switch (this.column.alignment) {
      case this.alignmentType.ALIGN_LEFT:
        this.alignClass = 'align-left';
        break;
      case this.alignmentType.ALIGN_CENTER:
        this.alignClass = 'align-center';
        break;
      case this.alignmentType.ALIGN_RIGHT:
        this.alignClass = 'align-right';
        break;
    }
  }

  asActionColumn(): ActionColumn {
    return this.column as ActionColumn;
  }

}
